import { render, staticRenderFns } from "./Reincidencia.vue?vue&type=template&id=62ea5d86&"
import script from "./Reincidencia.vue?vue&type=script&lang=js&"
export * from "./Reincidencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports